import { OwnerType } from "@/domain/_shared/lib/owner-types";
import { FileReplaceInput } from "@/graphql/generated/graphql";
import { createOperationClient } from "@/services/react-query.service/graphql-client";
import { queryKeys } from "@/services/react-query.service/query-keys";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { replaceFileMutationDocument } from "./file.gql";

export interface UseReplaceFileProps {
  id: string;
  ownerId: string;
  ownerType: OwnerType;
  onCompleted?: () => void;
  onError?: (e: Error) => void;
}

export const useReplaceFile = ({ id, ownerId, ownerType, onCompleted, onError }: UseReplaceFileProps) => {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: async (input: FileReplaceInput) => {
      const client = createOperationClient("replaceFile");
      return await client.request(replaceFileMutationDocument, { input });
    },
    onSuccess: () => {
      // Invalidate file queries
      queryClient.invalidateQueries({
        queryKey: queryKeys.files.list(ownerId, ownerType),
      });
      queryClient.invalidateQueries({
        queryKey: queryKeys.files.detail(id),
      });

      if (onCompleted) {
        onCompleted();
      }
    },
    onError: (error) => {
      if (onError) {
        onError(error);
      }
    },
  });

  return {
    replaceFile: mutation.mutateAsync,
    queryResult: mutation,
    loading: mutation.isPending,
  };
};
